module.exports = __webpack_public_path__ + "img/service2.8141a2cc.png";